<template>
  <div class="notifiGroupDetail-wrap">
    <div
      slot="header"
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >告警通知组信息</span
      >
      <el-button
        type="success"
        plain
        @click="cancel"
        style="float: right; padding: 3px 0"
        >返回</el-button
      >
    </div>
    <SForm
      ref="formref"
      :fields="formfields"
      :dataForm="rowdata"
      labelWidth="150px"
      :isShowBtn="false"
      :inline="false"
    >
    </SForm>
    <div class="clearfix" style="background-color: #f2f2f2; padding: 20px">
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >设备信息</span
      >
    </div>
    <el-form
        :model="form2"
        ref="form"
        label-width="150px"
        style="width: 600px; margin-top: 30px"
        class="device-form-wrap"
      >
        <el-form-item label="选择设备" style="width: 500px">
          <el-tree
            class="filter-tree"
            :data="datatree1"
            show-checkbox
            :props="defaultProps"
            default-expand-all
            node-key="id"
            :default-checked-keys="checkedNodes"
            ref="tree1"
          >
          </el-tree>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import { HOST, EV_HOST } from "@/utils/host";
const token = window.localStorage.getItem("token");
export default {
  name: "notifiGroupDetail",
  components: {},
  data() {
    return {
      rowdata: {},
      rowdataDevice: {},
      checkedNodes:[],
      datatree1:[],
      form2:{},
      formfields: [
        {
          label: "告警通知组名称",
          type: "div",
          prop: "name",
        },
        {
          label: "通知号码",
          type: "div",
          prop: "mobiles",
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      id: "",
      tableData: [],
    };
  },
  computed: {},
  methods: {
    cancel() {
      this.$router.go(-1);
    },

    getDataDetail(val) {
      let data = {
        id: this.id,
      };
      this.$store.dispatch("form/handle", {
        url: "/user/account/getDataDetail",
        method: "get",
        data: data,
        callback: (resp) => {
          console.log("resp2", resp);
          this.rowdata = resp;
          this.tableData = resp.list;
        },
      });
    },
  },
  mounted() {
    this.$nextTick(function() {
      let currentNotify = this.$route.query.data;
      this.rowdata = {
        name: currentNotify.name,
        mobiles: currentNotify.mobiles,
      };
      this.checkedNodes = currentNotify.deviceIDs.split(',');
    });
  },
  beforeCreate() {
    this.$store.dispatch("form/handle", {
      url: "/battery/tree/projectDevice",
      data: {},
      method: "get",
      callback: (resp) => {
        this.datatree1 = resp;
      },
    }); 
  }, //生命周期 - 创建之前
  beforeMount() {
    
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.resetbtn:hover {
  border: 1px solid #00cc00; 
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00; 
  color: #ffffff;
  background-color:#00cc00;
}
.device-form-wrap /deep/ .el-form-item__content {
  margin-left:230px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/notifiGroupManagement/notifiGroupDetail.vue